export const fireConfig = {
  apiKey: 'AIzaSyDdVt_7GDxyJ6-xQSQnBlkCE6VvlA7shtg',
  authDomain: 'radiolagauchita-pwa-live.firebaseapp.com',
  databaseURL: 'https://radiolagauchita-pwa-live.firebaseio.com',
  projectId: 'radiolagauchita-pwa-live',
  storageBucket: 'radiolagauchita-pwa-live.appspot.com',
  messagingSenderId: '292973259896',
  appId: '1:292973259896:web:716b8898ba3a7e0a95518d',
}
